import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { FOR_YOU } from '../data/content';
export function ForYouSection() {
  return <section className="py-10 sm:py-12" style={{
    paddingTop: "0px"
  }} data-id="element-94" data-mp="2cu80qptpvwq5">
      <div className="mx-auto max-w-content px-5" style={{
      paddingTop: "32px"
    }} data-id="element-95" data-mp="2cwawlqhjwk2s">
        <SectionHeading title="This is for you" highlight="if" data-id="element-96" data-mp="2hst0yp8yygel" />

        <ul className="mx-auto mt-6 max-w-3xl divide-y divide-ink-700 overflow-hidden rounded-2xl border border-ink-700 bg-ink-850" data-id="element-97" data-mp="1l3tpl1d38yi6">
          {FOR_YOU.map(item => <li key={item} className="flex items-start gap-3 px-5 py-2.5" data-id="element-98" data-mp="1p6q3ieroo6fs">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-lime-400" aria-hidden="true" data-id="element-99" data-mp="1u25emyyb3o8i" />
              <span className="text-sm leading-snug text-white/80" data-id="element-100" data-mp="1z4e95zqtuycq">{item}</span>
            </li>)}
        </ul>

        <p className="mt-5 text-center text-base font-extrabold text-lime-400 sm:text-lg" data-id="element-101" data-mp="35inaoxxzroum">
          If you checked even 1 — this pack is for you.
        </p>
      </div>
    </section>;
}